export * from './MathSpecs/const';
export {mathBType, mathIType} from './MathSpecs';

export const LATEX_MODES = new Set([
    'tex',
    'latex',
    'bibtex',
    'doctex',
    'latex-expl3',
    'pweave',
    'jlweave',
    'rsweave',
]);
